<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import repairAll from '../repairAll/index.vue'
import  repairSenven from '../repairSenven/index.vue'
export default {
	components:{
		repairAll,
		repairSenven
	},
	data() {
		return {
			//弹框
			repairallDiag:false,
			repairSenvendiag:false,
			//搜索 
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata, 
			overlength:0,
			//表格
			size:"",
			shaidiag:false,
			headData: JSON.parse(localStorage.getItem('mskInfoheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('mskInfooutlist')) || [],
			pagination: getdata().pagination, //分页数据
			tableData: [
				{
					tes1:"21983739281098",
					tes2:"111001909000",
					tes3:"4",
					tes4:"028",
					tes5:"2023-01-02  12:21:12  ",
					tes6:"21,123.09",
					tes7:"乌鲁木齐泛亚景观设计有限公司",
					tes8:"Apsc2304261655901",
					tes9:"2023-01-02  12:21:12",
					tes10:"2023-01-02  12:21:12",
					tes11:"文件导入",
				}
				], //表格内容数据
			tablekey: 0,
		}; 
	}, 
	mounted() {
	
	},
	created() {},
	methods: {
		//弹框
		forrepairallDiag(){
			this.repairallDiag=true
		},
		forrepairSenvendiag(){
			this.repairSenvendiag=true
		},
		closerepairallDiag(){
			this.repairallDiag=false
		},
		closerepairSenvendiag(){
			this.repairSenvendiag=false
		},
		//弹框
		geOoverLength(e) {
			this.overlength = e;
		},
		submitSearch(){
			
		},
		//表格体
		sortchange(e) {
			console.log(e) //排序
		},
		forSearchScreeningBox(obj) {
			console.log(obj) //筛选数组
		},
		currentChange(e) {
			this.pagination.pageNum = e;
		},
		sizechange(e) {
			this.pagination.pageSize = e;
		},
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('mskInfooutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('mskInfoheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
